/**
 * GOVOPS-1105 — Single Google Maps loader configuration for RobinhoodSpace CRA.
 * Do not call useJsApiLoader elsewhere; use GoogleMapsProvider + SafeGoogleMap.
 */

/** @deprecated Legacy loader id — must never appear in source or bundles. */
export const FORBIDDEN_MAPS_LOADER_ID = 'google-map-script';

/** Canonical @react-google-maps/api loader id (one script per app). */
export const MAPS_LOADER_ID = 'robinhoodspace-gmaps';

/** Frozen — never allocate a new libraries array per render. */
/** Places only — drawing/visualization removed (deprecated May 2026). */
export const MAPS_LIBRARIES = Object.freeze(['places']);

export const MAPS_LOADER_LANGUAGE = 'en';
export const MAPS_LOADER_REGION = 'US';

/**
 * Build loader options for the shared Maps loader hook (GoogleMapsContext only).
 * @param {string} googleMapsApiKey
 */
export function buildRobinhoodMapsLoaderOptions(googleMapsApiKey) {
  return Object.freeze({
    id: MAPS_LOADER_ID,
    googleMapsApiKey,
    libraries: MAPS_LIBRARIES,
    language: MAPS_LOADER_LANGUAGE,
    region: MAPS_LOADER_REGION,
  });
}
